import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import  LoginPage  from './pages/LoginPage';
import  HomePage  from './pages/HomePage';
import  RoomPage  from './pages/RoomPage';
import ConnectingPage  from './pages/ConnectingPage';
import  ProfilePage  from './pages/ProfilePage';
import  RegisterPage  from './pages/RegisterPage';

function App() {
    return (                
        <Router>
            <Routes>  
                <Route path = "/" element = { < HomePage /> } />     
                <Route path = "/login" element = { < LoginPage /> } /> 
                <Route path = "/home" element = { < HomePage /> } /> 
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/connecting/:customSessionId" element={<ConnectingPage />} />
                <Route path="/room/:customSessionId" element={<RoomPage/>} />
            </Routes>
        </Router>
    );
}

export default App;